console.log(window.location.pathname);
if (new URLSearchParams(window.location.search).get("test") != "1") {
if(window.location.pathname == '/pages/sso-redirect') {

    //window.onload = handleRedirect;

  document.addEventListener("DOMContentLoaded", () => {
    // Extract query parameters from the URL
    const params = new URLSearchParams(window.location.search);
    const authCode = params.get("code");
    const state = params.get("state"); // Optional, for state verification

    if (authCode) {
        console.log("Authorization Code:", authCode);

        // Exchange the authorization code for tokens
        const codeVerifier = "BdB92rYgQj5laokbyRKiJS6CtJetVZNjyflkK8h_yAI"; // Use the same as during authorization request
        exchangeCodeForTokens(authCode, codeVerifier, state);
    } else {
        console.error("Authorization code not found in the URL.");
    }
});
}
if(window.location.pathname == '/pages/account') {
    if(ssonIsLoggedIn()) {
        const userInfo = parseJwt(localStorage.getItem("ssonIdToken"));
          console.log("User Info:", userInfo);
        const fieldsToDisplay = [
              "name",
              "emailaddress",
              "given_name",
              "family_name",
              "address",
              "postal_code",
              "city",
              "country",
              "phone",
              "customer_number"
          ];
      // displayProfile(userInfo,fieldsToDisplay);
      displayProfileOnAccount(userInfo);
    } else {
      window.location.href = "/";
    }
}

function displayProfile(data, fields) {
            const container = document.getElementById('sson-userdata');
            const table = document.createElement('table');
            const thead = document.createElement('thead');
            const tbody = document.createElement('tbody');

            // Create table headers
            const headerRow = document.createElement('tr');
            const headerKey = document.createElement('th');
            headerKey.textContent = "Field";
            const headerValue = document.createElement('th');
            headerValue.textContent = "Value";
            headerRow.appendChild(headerKey);
            headerRow.appendChild(headerValue);
            thead.appendChild(headerRow);

            // Populate table rows with selected fields
            fields.forEach(field => {
                if (data[field] !== undefined) {
                    const row = document.createElement('tr');
                    const keyCell = document.createElement('td');
                    const valueCell = document.createElement('td');

                    keyCell.textContent = field.replace(/_/g, " ").toUpperCase(); // Format field names
                    valueCell.textContent = data[field] !== null ? data[field] : "N/A";

                    row.appendChild(keyCell);
                    row.appendChild(valueCell);
                    tbody.appendChild(row);
                }
            });

            table.appendChild(thead);
            table.appendChild(tbody);
            container.appendChild(table);
        }
// Function to update the element if it exists
function updateSSOElement(id, value) {
    const element = document.getElementById(id);
    if (element && value) {
        element.innerHTML = value;
    }
    if(value == '') {
      hideParent(id, value);
    }
    
}
function hideParent(childId, value) {
    const parentId = `${childId}_container`;
    const parentElement = document.getElementById(parentId);
    if (parentElement) {
        parentElement.style.display = value ? "block" : "none";
    }
}

function displayProfileOnAccount(userData) {
    updateSSOElement("sso_customer_number", userData.customer_number);
    updateSSOElement("sso_customer_name", userData.given_name + " "+userData.family_name);
    updateSSOElement("sso_customer_birthdate", userData.birthdate);
    updateSSOElement("sso_customer_email", userData.emailaddress);
    updateSSOElement("sso_customer_phone", userData.phone);
    // Formatting the address
    const formattedAddress = `${userData.address} <br> ${userData.postal_code} ${userData.city}`;
    updateSSOElement("sso_customer_address", formattedAddress);

}
async function exchangeCodeForTokens(authCode, codeVerifier,state) {
    //const tokenEndpoint = "https://fcsgb2c.b2clogin.com/fcsgb2c.onmicrosoft.com/oauth2/v2.0/token";
  console.log('state',state);
  let tokenEndpoint;
    if(state){
      tokenEndpoint = "https://fcsgb2c.b2clogin.com/fcsgb2c.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/oauth2/v2.0/token";
    } else {
      tokenEndpoint = "https://fcsgb2c.b2clogin.com/fcsgb2c.onmicrosoft.com/B2C_1A_PROFILE_EDIT/oauth2/v2.0/token";
    }
    console.log('tokenEndpoint',tokenEndpoint);
  
    const clientId = "c7a4f00b-4997-47ef-afea-ca5e27f0819d";
    const redirectUri = "https://fcsgweb.myshopify.com/pages/sso-redirect";

    const params = new URLSearchParams();
    params.append("grant_type", "authorization_code");
    params.append("code", authCode);
    params.append("client_id", clientId);
    params.append("redirect_uri", redirectUri);
    params.append("code_verifier", codeVerifier);

    try {
        const response = await fetch(tokenEndpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: params.toString(),
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Token Response:", data);

        const idToken = data.id_token;
        const accessToken = data.access_token;

        localStorage.setItem("ssonIdToken", idToken);
        localStorage.setItem("ssonAccessToken", accessToken);
window.location.href = '/pages/account';
        const userInfo = parseJwt(idToken);
        console.log("User Info:", userInfo);
        // Proceed to authenticate the user in your app using the tokens
    } catch (error) {
        console.error("Error exchanging code for tokens:", error);
    }
}

function ssonIsLoggedIn() {
    return !!localStorage.getItem("ssonIdToken");
}

function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}

function logout() {
    const logoutEndpoint = "https://fcsgb2c.b2clogin.com/fcsgb2c.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/oauth2/v2.0/logout";
    try {
        // Make an async call to the logout endpoint
        const response = fetch(logoutEndpoint, {
            method: "GET",
            mode: "cors",  // Ensures cross-origin requests work if needed
            credentials: "include" // Ensures cookies/session data are sent
        });

        if (!response.ok) {
            throw new Error(`Logout failed with status: ${response.status}`);
        }
        console.log("Logout successful.");

    } catch (error) {
        console.error("Error during logout:", error);
    }
   // Clear tokens from local storage
  localStorage.removeItem("ssonIdToken");
  localStorage.removeItem("ssonAccessToken");
  // Redirect the user after logout
  window.location.href = "/";
}



document.addEventListener("DOMContentLoaded", function () {
   console.log('here');
    const loginIconContainer = document.getElementById("sso_login_status");
    const loginTextContainer = document.getElementById("sso_login_text");
    const loginLink = document.getElementById("sso_login_link");
     if (ssonIsLoggedIn()) {
       console.log('here2');
        const ssoUser = parseJwt(localStorage.getItem("ssonIdToken"));
        // User is logged in
        let firstInitial = ssoUser.given_name ? ssoUser.given_name[0].toUpperCase() : "";
        let lastInitial = ssoUser.family_name ? ssoUser.family_name[0].toUpperCase() : "";

        // Show initials as the account icon
        let userAvatarHTML = `
            <account-icon>${firstInitial}${lastInitial}</account-icon>
        `;
        loginIconContainer.innerHTML = userAvatarHTML;
        loginTextContainer.innerText = "Mein FCSG";

        // Redirect to account page instead of SSO login
        loginLink.setAttribute("href", "/pages/account");

    }
    const logoutButton = document.getElementById("ssoLogoutButton");
    logoutButton.addEventListener("click", function () {
      logout();
      return false;
    });
    const profileUpdateButton = document.getElementById("HeaderMenu-profildaten");
  
    profileUpdateButton.addEventListener("click", function () {
         window.location.href="https://fcsgb2c.b2clogin.com/fcsgb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_PROFILE_EDIT&client_id=c7a4f00b-4997-47ef-afea-ca5e27f0819d&nonce=defaultNonce&redirect_uri=https%3A%2F%2Ffcsgweb.myshopify.com%2Fpages%2Fsso-redirect&scope=openid&response_type=code&prompt=login&code_challenge=BdB92rYgQj5laokbyRKiJS6CtJetVZNjyflkK8h_yAI";
         return false;
    });
    console.log('here1');
   
});
}